// 双管齐下加渐进增强策略:
// 1. 只使用 overflow: hidden 来保障副作用最小
// 2. 在 ios 下仍然使用 overscroll 行为来保障
// 3. 使用 css 的 overscroll-behavior: contain
// 4. 安卓特殊设备和 UA 采用降级策略

import $ from "zepto-modules";

class OverscrollBehavior {

  constructor(options) {
    this.lockAreas = options.lockAreas || [];
    this.overscrollBehaviors = options.overscrollBehaviors || [];
    this.noRoundCheck = options.noRoundCheck || false;
    this.lastY = null;
    // 回合是否结束
    this.roundOver = false;
    // 回合内是否继续阻止
    this.inPreventRound = false;
    // 单例保障
    this._innerOverScrollHandlers = {
      'default': () => {},
      'contain': this._overscrollContainHandler
    };
    // 是否需要降级
    this.ifNeedToFallback = (() => {
      // fallback device
      const isUC = navigator.userAgent.indexOf("UC") != -1;
      const isXiaoMi = navigator.userAgent.indexOf("XiaoMi") != -1;
      return (isUC || isXiaoMi);
    })();
  }

  _lockAreaHandler(e) {
    // 锁区直接阻止
    e.cancelable && e.preventDefault();
  }

  _overscrollContainHandler(e) {
    const self = this.$$instance;

    // 模拟禁止滚动联结
    const selfDom = $(this).parent(),
      height = selfDom[0].clientHeight,
      scrollDomHeight = selfDom[0].scrollHeight,
      maxScrollDistance = scrollDomHeight - height;

    if (e.type === 'touchstart') {
      // reset
      self.roundOver = false;
      self.lastY = (e.touches[0] || e).pageY;
    }

    if (e.type === 'touchmove') {
      // 永远标记回合结束
      if (self.noRoundCheck) self.roundOver = true;

      const moveY = (e.touches[0] || e).pageY;

      const scrollTop = selfDom.scrollTop();
      const reachTop = scrollTop == 0;

      // 1 为灵敏度，有的情况下会少 1 像素
      const reachBottom = scrollTop + 1 >= maxScrollDistance;

      const overScroll = (reachTop && moveY > self.lastY) ||
        (reachBottom && moveY < self.lastY);

      // 如果出现一次 overScroll 并且回合并未结束
      if (overScroll && !self.roundOver) {
        self.inPreventRound = true;
      }

      (self.inPreventRound || overScroll) &&
        e.cancelable &&
        e.preventDefault();
    }

    if (e.type === 'touchend') {
      // 回合结束
      self.inPreventRound = false;
      self.roundOver = true;
    }
  }

  getOverScrollHandler(beType, ele) {
    ele[0].$$instance = this;
    return this._innerOverScrollHandlers[beType];
  }

  start() {
    // fallback under some special browsers
    if (this.ifNeedToFallback) {
      $('html').addClass('uc');
    }

    $('html').addClass('noscroll');

    this.lockAreas.forEach(el => {
      $(el).on('touchmove', this._lockAreaHandler);
    });

    this.overscrollBehaviors.forEach(be => {
      const overScrollEle = be[0],
        beType = be[1];
      
      $(overScrollEle).on('touchstart touchmove touchend', this.getOverScrollHandler(beType, $(overScrollEle)));
    });
  }

  stop() {
    // reset
    if (this.ifNeedToFallback) {
      $('html').removeClass('uc');
    }

    $('html').removeClass('noscroll');

    this.lockAreas.forEach(el => {
      $(el).off('touchmove', this._lockAreaHandler);
    });

    this.overscrollBehaviors.forEach(be => {
      const overScrollEle = be[0],
        beType = be[1];

      $(overScrollEle).off('touchstart touchmove touchend', this.getOverScrollHandler(beType, $(overScrollEle)));
    });
  }
};

export default OverscrollBehavior;



// WEBPACK FOOTER //
// ./src/util/behavior.js